import * as THREE from "three";

export class Lights {
  constructor(stage) {
    this.plight = null;
    this.stage = stage;
  }

  init() {
    this.setLight();
  }

  setLight() {
    // const directionalLight = new THREE.DirectionalLight(0xffffff, 0.2);
    // directionalLight.position.set(-5, 5, 5);
    // this.stage.scene.add(directionalLight);

    const plight = new THREE.PointLight(0xffffff, 10.0, 10, 0.5);
    plight.position.set(-1, 3, 4);
    this.stage.scene.add(plight);
    this.plight = plight;
  }

  onRaf(elapsed) {
    this.plight.position.y = Math.sin(elapsed) * 3;
    this.plight.position.x = Math.cos(elapsed) * 1;
  }
}
